import { render, staticRenderFns } from "./SalesViewList.vue?vue&type=template&id=108d2f52&scoped=true&"
import script from "./SalesViewList.vue?vue&type=script&lang=js&"
export * from "./SalesViewList.vue?vue&type=script&lang=js&"
import style0 from "./SalesViewList.vue?vue&type=style&index=0&id=108d2f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d2f52",
  null
  
)

export default component.exports